import mainTheme from "@irati/ui/src/global/theme"
import styled from "styled-components"

const CompanyValuesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${mainTheme.spacing.half};
  justify-content: center;
  margin: 5px 0;
`

export default CompanyValuesWrapper
